<div id="main-container">
    <app-navbar></app-navbar>
    <dx-tab-panel
      id="main-tabs"
      [dataSource]="availableTabs"
      [selectedIndex]="selectedIndex"
      itemTitleTemplate="tabTitle"
      (onSelectionChanged)="onTabChange($event)"
      tabsPosition="left"
      iconPosition="top"
    >
      <div *dxTemplate="let title of 'tabTitle'">
        <div class="dx-item-content dx-tab-content">
          <div class="dx-tab-text">
            <i class="dx-icon dx-icon-{{title.icon}}"></i>
            <span class="dx-tab-text-span">
              {{ title.title }}
            </span>
          </div>
        </div>
      </div>

    <div *dxTemplate="let template of 'monitoring'">
        <app-monitoring-overview></app-monitoring-overview>
      </div>


  </dx-tab-panel>
<!-- <dx-data-grid
    #dataGrid
    id="dataGrid"
    [dataSource]="dataStore"
    [showBorders]="true"
    [columnAutoWidth]="true"
    [wordWrapEnabled]="true"
    [editing]="{ allowUpdating: false, allowAdding: false, allowDeleting: false }"
>
    <dxi-column caption="Host" dataField="host" dataType="string" alignment="left"></dxi-column>
    <dxi-column caption="Aktualisierungszeit" dataField="duration" dataType="decimal" alignment="left"></dxi-column>
    <dxi-column caption="Durchschnittl. Aktualisierungszeit" dataField="average_duration" dataType="decimal" alignment="left"></dxi-column>
    <dxi-column caption="Letzte Aktualisierung" dataField="last_update" dataType="date" alignment="left"></dxi-column>
    <dxo-paging [pageSize]="20"></dxo-paging>
    <dxo-pager
      [visible]="true"
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[20, 50, 100]"
    ></dxo-pager>
</dx-data-grid>
     -->


</div>